let report = (function () {
    $("#vm_type").prop("disabled", true);
    $("#group").prop("disabled", true);
    $("#strongbox").prop("disabled", true);
    $("#tag").prop("disabled", true);
    $("#vm").prop("disabled", true);

    let initListing = function () {
        $("#vm_type_check").on("click", function () {
            $("#vm_type_check").is(":checked")
                ? $("#vm_type").prop("disabled", false)
                : $("#vm_type").prop("disabled", true);
        });

        $("#group_check").on("click", function () {
            $("#group_check").is(":checked")
                ? $("#group").prop("disabled", false)
                : $("#group").prop("disabled", true);
        });

        $("#vm_check").on("click", function () {
            $("#vm_check").is(":checked")
                ? $("#vm").prop("disabled", false)
                : $("#vm").prop("disabled", true);
        });
    };

    return {
        // public functions
        init: function () {
            initListing();
        },
    };
})();

$(document).ready(function () {
    report.init();
    $("#reports-table").DataTable({
        processing: true,
        serverSide: false,
        paginate: false,
        info: false,
    });
});
